<template>
  <div>
    <app-header></app-header>
      <div v-on:click="hideBlock">
        <v-layout row wrap>
          <v-flex xs12 md12 lg12 sm12 class="col-height-auto">
              <div class="profile-head">
                <div class="profile-top" :style="{backgroundImage: 'url('+userDetail.coverImage+')'}">
                </div>
                <div class="profile-bottom">
                  <div class="user-image text-xs-center mb-3">
                      <v-avatar color="primary pointer" size="100" @click="openNewWindowViewImage(userDetail.image)">
                        <img v-show="userDetail.image != null" :src="userDetail.image" :alt="userDetail.userName" />
                        <span v-show="userDetail.image == null" class="font-50 white--text">
                          {{ userDetail.userName != null ? userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : ''}}
                        </span>
                      </v-avatar>
                    <!--头像预览modal-->
                    <Modal v-model="isShowViewImageModal">
                      <p slot="header"></p>
                      <div>
                        <img v-bind:src="userDetail.image" style="width: 100%">
                      </div>
                      <div slot="footer"></div>
                    </Modal>
                  </div>
                  <div class="user-list-content mb-5">
                    <div class="text-xs-center">
                      <h1 class="fw-bold">{{userDetail.nickName}} ({{userDetail.reputationScore}})</h1>
                      <h3>IOB Power: <span class="font-26 primary--text">{{((userDetail.iobPower != null ? userDetail.iobPower : 0).toFixed(2))|NumFormat}}</span></h3>
                      <div class="font-16 fw-500 mt-3">
                        <span class="mx-3">
                          <v-icon small>fas fa-at</v-icon><span class="ml-1">{{userDetail.userName}}</span>
                        </span>
                        <span>
                          <v-icon small>fas fa-calendar-alt</v-icon><span class="ml-1">{{regTimeFormat(userDetail.regTime)}}</span>
                        </span>
                      </div>
                      <div class="social-list clearfix mb-4" v-if="username != this.$store.state.user.name">
                        <v-btn color="primary" @click="follow" dark>
                          <span v-show="!isFollow">
                            <Icon type="plus-round" color="#FFFFFF"></Icon>
                            <span>{{$t("common.follow")}}</span>
                          </span>
                          <span v-show="isFollow">
                            <span>{{$t("common.unfollow")}}</span>
                          </span>
                        </v-btn>
                      </div>
                      <div class="h4 mt-3">
                        <span class="primary--text pointer mr-2" @click="goFollow('following')">
                          {{followingNum}} {{$t("follow.following")}}
                        </span>
                        <span class="primary--text pointer ml-2" @click="goFollow('followers')">
                          {{followerNum}} {{$t("follow.followers")}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </v-flex>
        </v-layout>
         <v-container grid-list-xl mt-5 mb-5 pb-5 align-center justify-center>
          <v-layout row wrap justify-center>
            <v-flex xs12 md5 lg3>
              <div class="inbox-head">
                <div class="mailbox-items-warp">
                  <div class="app-card">
                    <v-list>
                      <v-list-tile @click="getMenuData('posting')" :title="$t('userData.posting') + '(' + totalPostingNum + ')'">
                        <v-list-tile-action>
                          <v-icon>fa fa-file-alt</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t("userData.posting")}}({{totalPostingNum}})
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <!-- <v-list-tile @click="getMenuData('microArticle')">
                          <v-list-tile-action>
                              <v-icon>fa fa-file</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                              <v-list-tile-title>
                                  {{$t("userData.microArticle")}}({{totalMicroArticleNum}})
                              </v-list-tile-title>
                          </v-list-tile-content>
                      </v-list-tile>
                        -->
                      <v-list-tile @click="getMenuData('comments')" :title="$t('userData.comments') + '(' + totalRewardRecordsNum + ')'">
                        <v-list-tile-action>
                          <v-icon>fa fa-comment</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t("userData.comments")}}({{totalCommentsNum}})
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile @click="getMenuData('reply')" :title="$t('userData.reply') + '(' + totalReplyNum + ')'">
                        <v-list-tile-action>
                          <v-icon>fa fa-reply</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t("userData.reply")}}({{totalReplyNum}})
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile @click="getMenuData('forward')" :title="$t('userData.forward') + '(' + totalForwardNum + ')'">
                        <v-list-tile-action>
                          <v-icon>fa fa-share</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t("userData.forward")}}({{totalForwardNum}})
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile @click="getMenuData('upvotes')" :title="$t('userData.upvotes') + '(' + totalUpvoteNum + ')'">
                        <v-list-tile-action>
                          <v-icon>thumb_up</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t("userData.upvotes")}}({{totalUpvoteNum}})
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile @click="getMenuData('downvotes')" :title="$t('userData.downvotes') + '(' + totalDownvoteNum + ')'">
                        <v-list-tile-action>
                          <v-icon>thumb_down</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t("userData.downvotes")}}({{totalDownvoteNum}})
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile @click="getMenuData('collections')" :title="$t('userData.favorites') + '(' + totalCollectionPostNum + ')'">
                        <v-list-tile-action>
                          <v-icon>fa fa-star</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t("userData.favorites")}}({{totalCollectionPostNum}})
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile @click="getMenuData('referees')" :title="$t('userData.referees') + '(' + userDetail.invitationNumber + ')'">
                        <v-list-tile-action>
                          <v-icon>accessibility</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t("userData.referees")}}({{userDetail.invitationNumber}})
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile @click="getMenuData('rewardRecords')" :title="$t('userData.rewardRecords') + '(' + totalRewardRecordsNum + ')'">
                        <v-list-tile-action>
                          <v-icon>fas fa-clipboard</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t("userData.rewardRecords")}}({{totalRewardRecordsNum}})
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 md7 lg9 class="inbox-content">
                <div class="inbox-content-wrap">
                    <v-card> 
                        <v-container fluid>
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - -帖子- - - - - - - - - - - - - - - - -  -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->

                  <div v-show="isShowPosting">
                    <h2 class="fw-700 mb-5">{{$t("userData.posting")}}</h2>
                    <div v-for="(posting,index) in postingList" class="media-listing">
                      <ul class="list-unstyled">
                        <li class="media border-bottom-light-1">
                          <!-- - - - - - - - - - -  帖子图片- - - - - - - - - - - - - - -->
                          <span class="rounded-circle mr-4 img-responsive posting-image pointer" v-if="posting.postingImg!=''" v-html="posting.postingImg" @click="getPostingById(posting.postingId)">
                          </span>
                          <div class="media-body">
                            <!-- - - - - - - - - - -  标题- - - - - - - - - - - - - - -->
                            <h2 class="fw-700" @click="getPostingById(posting.postingId)">
                              {{posting.postingTitle}}
                            </h2>
                            <p class="mb-0 font-14 fw-400">
                              <span v-if="posting.postingContent.length = 0"></span>
                              <span v-if="posting.postingContent.length < 30">
                                {{posting.postingContent}}
                              </span>
                              <span v-else>{{posting.postingContent}}……</span>
                            </p>
                            <div class="social-list clearfix mb-4">
                              <ul class="list-inline d-inline-block">
                                <li @click="getPostingById(posting.postingId)">
                                  <v-icon small>thumb_up_alt</v-icon> 
                                      <span class="font-14 fw-400 ml-1">
                                        {{posting.postingGoodnums}}
                                    </span>
                                </li>
                                <li @click="getPostingById(posting.postingId)">
                                  <v-icon small>thumb_down_alt</v-icon> 
                                      <span class="font-14 fw-400 ml-1">
                                        {{posting.postingStepnums}}
                                    </span>
                                </li>
                                <li @click="getPostingById(posting.postingId)">
                                  <v-icon small>fa fa-comment</v-icon>
                                  <span class="font-14 fw-400 ml-1">
                                      {{posting.postingCountComments}}
                                </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div v-show="postingList.length > 0">
                      <Page :total="totalPostingNum" :pageSize="5" size="small" transfer @on-change="getPostingByPage" class="mt-2 mb-5 text-xs-center"></Page>
                    </div>
                  </div>
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - -微文- - - - - - - - - - - - - - - - -  -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->

                  <div v-show="isShowMicroArticle">
                    <h2 class="fw-bold mt-5 mb-5">{{$t("userData.microArticle")}}</h2>
                    <div v-for="(microArticle,index) in microArticleList" class="media-listing">
                      <div class="mt-3 mb-3 ml-3 mr-3">
                        <div class="mt-3 font-md pointer hover-color" @click="gotoMicroArticle(microArticle)">
                          {{microArticle.content}}
                        </div>
                      </div>
                      <div class="mr-5 right">
                        <v-icon small :class="{'primary--text':microArticle.isUpvote}" :title="$t('posting.upvote')" @click="voteMicroArticle(microArticle, '0')">thumb_up</v-icon>
                        {{microArticle.upvoteCount}}
                        <v-icon small :title="$t('posting.comment')" class="ml-3" @click="gotoMicroArticle(microArticle)">fa fa-comment</v-icon>
                        {{microArticle.commentCount}}
                      </div>
                      <v-divider class="mt-5"></v-divider>
                    </div>
                    <div v-show="microArticleList.length > 0">
                      <Page :total="totalMicroArticleNum" :pageSize="5" size="small" transfer @on-change="getMicroArticleByPage" class="mt-2 mb-5 text-xs-center"></Page>
                    </div>
                  </div>

                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - -评论- - - - - - - - - - - - - - - - -  -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <div v-show="isShowComments">
                    <h3 class="fw-700 mb-5">{{$t("userData.comments")}}</h3>
                    <div v-for="(comments,index) in postingCommentsList" class="media-listing">
                      <ul class="list-unstyled">
                        <li class="media border-bottom-light-1">
                          <div class="media-body">
                            <!-- - - - - - - - - - -  标题- - - - - - - - - - - - - - -->
                            <div v-for="(posting,index) in commentsPostingList">
                              <p class="font-16 fw-500"  @click="getPostingById(posting.postingId)" v-if="comments.commentsPostingId == posting.postingId">
                                <span class="fw-700">{{$t("userData.posting")}}:</span>
                                 {{posting.postingTitle}}
                              </p>
                            </div>
                            <p class="mb-0 font-14 fw-400">
                              <!-- - - - - - - - - - -  内容- - - - - - - - - - - - - - -->
                              <span class="fw-700">{{$t("userData.comment")}}:</span>
                              <span v-if="comments.commentsContext.length = 0" class="small">&nbsp;</span>
                              <span v-if="comments.commentsContext.length < 30" class="small">
                                {{comments.commentsContext}}
                              </span>
                              <span v-else>{{comments.commentsContext}}……</span>
                            </p>
                            <div class="social-list clearfix">
                              <!-- - - - - - - - - - -  图标- - - - - - - - - - - - - - -->
                              <ul class="list-inline d-inline-block">
                                <li>
                                  <v-icon small>thumb_up_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1"> {{comments.postingCommentsGoodnums}}</span>
                                  <!-- <i class="thumb_up_alt"></i> -->
                                </li>
                                <li>
                                  <v-icon small>thumb_down_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{comments.postingCommentsStepnums}}</span>
                                </li>
                                <li>
                                  <v-icon small>fa fa-comment</v-icon>
                                  <span class="font-14 fw-400 ml-1"> {{comments.postingCommentList.length}}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div v-show="postingCommentsList.length > 0">
                      <Page :total="totalCommentsNum" :pageSize="5" size="small" transfer @on-change="getCommentsByPage" class="mt-2 mb-5 text-xs-center"></Page>
                    </div>
                  </div>
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - -回复- - - - - - - - - - - - - - - - -  -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <div v-show="isShowReply">
                    <h3 class="fw-700 mb-5">{{$t("userData.reply")}}</h3>
                    <div v-for="(reply,index) in postingReplyList" class="media-listing">
                      <ul class="list-unstyled">
                        <li class="media border-bottom-light-1">
                          <div class="media-body">
                            <!-- - - - - - - - - - -  父级评论- - - - - - - - - - - - - - -->
                            <div v-for="(comments,index) in parentCommentList">
                              <p class="font-16 fw-500 word-break" @click="getPostingById(comments.commentsPostingId)" v-if="comments.commentsId == reply.parentCommentId">
                               <span class="fw-700">{{$t("userData.comment")}}：</span>
                                <span v-html="comments.commentsContext"></span>
                              </p>
                            </div>
                            <p class="mb-0 font-14 fw-400">
                              <!--  - - - - - - - - - -  内容- - - - - - - - - - - - - - -->
                              <span class="fw-700">{{$t("userData.reply")}}：</span>
                              <span v-if="reply.commentsContext.length = 0">&nbsp;</span>
                              <span v-if="reply.commentsContext.length < 30">
                                {{reply.commentsContext}}
                              </span>
                              <span v-else>{{reply.commentsContext}}……</span>
                            </p>
                            <div class="social-list clearfix">
                              <!-- - - - - - - - - - -  图标- - - - - - - - - - - - - - -->
                              <ul class="list-inline d-inline-block">
                                <li @click="">
                                  <v-icon small>thumb_up_alt</v-icon> 
                                  <span class="font-14 fw-400 ml-1"> {{reply.postingCommentsGoodnums}}</span>
                                </li>
                                <li @click="">
                                  <v-icon small>thumb_down_alt</v-icon>
                                   <span class="font-14 fw-400 ml-1"> {{reply.postingCommentsStepnums}}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div v-show="postingReplyList.length > 0">
                      <Page :total="totalReplyNum" :pageSize="5" size="small" transfer @on-change="getReplyByPage" class="mt-2 mb-5 text-xs-center"></Page>
                    </div>
                  </div>
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - -转发- - - - - - - - - - - - - - - - -  -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <div v-show="isShowForward">
                    <h3 class="fw-700 mb-5">{{$t("userData.forward")}}</h3>
                    <div v-for="(posting,index) in postingForwardList" class="media-listing">
                      <div class="font-md mt-3">
                        <!-- <i class="fa fa-share"></i> -->
                        <v-icon>fa fa-share</v-icon>
                        <span class="fw-700 mr-1">{{$t("userData.forwarded")}}</span>
                      </div>
                      <ul class="list-unstyled">
                        <li class="media border-bottom-light-1">
                          <!-- - - - - - - - - - -  帖子图片- - - - - - - - - - - - - - -->
                          <span class="rounded-circle mr-4 img-responsive posting-image" v-if="posting.postingImg!=''" v-html="posting.postingImg"></span>
                          <div class="media-body">
                            <!-- - - - - - - - - - -  标题- - - - - - - - - - - - - - -->
                            <h2 class="fw-700" @click="getPostingById(posting.postingId)">
                              {{posting.postingTitle}}
                            </h2>
                            <p class="mb-0 font-14 fw-400">
                              <span v-if="posting.postingContent.length = 0">&nbsp;</span>
                              <span v-if="posting.postingContent.length < 30">
                                {{posting.postingContent}}
                              </span>
                              <span v-else>{{posting.postingContent}}……</span>
                            </p>
                            <div class="social-list clearfix">
                              <!-- - - - - - - - - - -  图标- - - - - - - - - - - - - - -->
                              <ul class="list-inline d-inline-block">
                                <li @click="getPostingById(posting.postingId)">
                                  <v-icon small>thumb_up_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingGoodnums}}</span>
                                </li>
                                <li @click="getPostingById(posting.postingId)">
                                  <v-icon small>thumb_down_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingStepnums}}</span>
                                </li>
                                <li @click="getPostingById(posting.postingId)">
                                  <v-icon small>fa fa-comment</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingCountComments}}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div v-show="postingForwardList.length > 0">
                      <Page :total="totalForwardNum" :pageSize="5" size="small" transfer @on-change="getForwardByPage" class="mt-2 mb-5 text-xs-center"></Page>
                    </div>
                  </div>
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - -我的点赞- - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <div v-show="isShowUpvotes">
                    <h2 class="fw-700 mb-5">{{$t("userData.upvotes")}}</h2>
                    <div v-for="(posting,index) in upvotePostList" class="media-listing">
                      <ul class="list-unstyled">
                        <li class="media border-bottom-light-1">
                          <!-- - - - - - - - - - -  帖子图片- - - - - - - - - - - - - - -->
                          <span class="rounded-circle mr-4 img-responsive posting-image" v-if="posting.postingImg!=''" v-html="posting.postingImg">
                          </span>
                          <div class="media-body">
                            <!-- - - - - - - - - - -  标题- - - - - - - - - - - - - - -->
                            <h2 class="fw-700" @click="getPostingById(posting.postingId)">
                              {{posting.postingTitle}}
                            </h2>
                            <p class="mb-0 font-14 fw-400">
                              <span v-if="posting.postingContent.length = 0"></span>
                              <span v-if="posting.postingContent.length < 30">
                                {{posting.postingContent}}
                              </span>
                              <span v-else>{{posting.postingContent}}……</span>
                            </p>
                            <div class="social-list clearfix mb-4">
                              <ul class="list-inline d-inline-block">
                                <li @click="getPostingById(posting.postingId,posting.postingUserId)">
                                  <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">thumb_up_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingGoodnums}}</span>
                                </li>
                                <li>
                                  <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">thumb_down_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingStepnums}}</span>
                                </li>
                                <li>
                                  <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">fa fa-comment</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingCountComments}}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div v-show="upvotePostList.length > 0">
                      <Page :total="totalUpvoteNum" :pageSize="5" size="small" transfer @on-change="getUpvotePostListByPage" class="mt-2 mb-5 text-xs-center"></Page>
                    </div>
                  </div>
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - -我的点踩- - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <div v-show="isShowDownvotes">
                    <h2 class="fw-700 mb-5">{{$t("userData.downvotes")}}</h2>
                    <div v-for="(posting,index) in downvotePostList" class="media-listing">
                      <ul class="list-unstyled">
                        <li class="media border-bottom-light-1">
                          <!-- - - - - - - - - - -  帖子图片- - - - - - - - - - - - - - -->
                          <span class="rounded-circle mr-4 img-responsive posting-image" v-if="posting.postingImg!=''" v-html="posting.postingImg">
                          </span>
                          <div class="media-body">
                            <!-- - - - - - - - - - -  标题- - - - - - - - - - - - - - -->
                            <h2 class="fw-700" @click="getPostingById(posting.postingId)">
                              {{posting.postingTitle}}
                            </h2>
                            <p class="mb-0 font-14 fw-400">
                              <span v-if="posting.postingContent.length = 0"></span>
                              <span v-if="posting.postingContent.length < 30">
                                {{posting.postingContent}}
                              </span>
                              <span v-else>{{posting.postingContent}}……</span>
                            </p>
                            <div class="social-list clearfix mb-4">
                              <ul class="list-inline d-inline-block">
                                <li @click="getPostingById(posting.postingId,posting.postingUserId)">
                                  <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">thumb_up_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingGoodnums}}</span>
                                </li>
                                <li>
                                  <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">thumb_down_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingStepnums}}</span>
                                </li>
                                <li>
                                  <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">fa fa-comment</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingCountComments}}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div v-show="downvotePostList.length > 0">
                      <Page :total="totalDownvoteNum" :pageSize="5" size="small" transfer @on-change="getDownvotePostListByPage" class="mt-2 mb-5 text-xs-center"></Page>
                    </div>
                  </div>
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - -我的喜欢- - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <div v-show="isShowCollections">
                    <h2 class="fw-700 mb-5">{{$t("userData.favorites")}}</h2>
                    <div v-for="(posting,index) in collectionPostList" class="media-listing">
                      <ul class="list-unstyled">
                        <li class="media border-bottom-light-1">
                          <!-- - - - - - - - - - -  帖子图片- - - - - - - - - - - - - - -->
                          <span class="rounded-circle mr-4 img-responsive posting-image" v-if="posting.postingImg!=''" v-html="posting.postingImg">
                          </span>
                          <div class="media-body">
                            <!-- - - - - - - - - - -  标题- - - - - - - - - - - - - - -->
                            <h2 class="fw-700" @click="getPostingById(posting.postingId)">
                              {{posting.postingTitle}}
                            </h2>
                            <p class="mb-0 font-14 fw-400">
                              <span v-if="posting.postingContent.length = 0"></span>
                              <span v-if="posting.postingContent.length < 30">
                                {{posting.postingContent}}
                              </span>
                              <span v-else>{{posting.postingContent}}……</span>
                            </p>
                            <div class="social-list clearfix mb-4">
                              <ul class="list-inline d-inline-block">
                                <li @click="getPostingById(posting.postingId,posting.postingUserId)">
                                  <!--  <i class="ti-angle-up"></i> <span>{{posting.postingGoodnums}}</span> -->
                                  <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">thumb_up_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingGoodnums}}</span>
                                </li>
                                <li>
                                  <!--  <i class="ti-angle-down"></i> <span>{{posting.postingStepnums}}</span> -->
                                  <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">thumb_down_alt</v-icon>
                                  <span class="font-14 fw-400 ml-1">{{posting.postingStepnums}}</span>
                                </li>
                                <li>
                                  <!-- <i class="ti-comment"></i><span>{{posting.postingCountComments}}</span> -->
                                  <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">fa fa-comment</v-icon>
                                    <span class="font-14 fw-400 ml-1">{{posting.postingCountComments}}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div v-show="collectionPostList.length > 0">
                      <Page :total="totalCollectionPostNum" :pageSize="5" size="small"  transfer @on-change="getCollectionPostByPage" class="mt-2 mb-5 text-xs-center"></Page>
                    </div>
                  </div>
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - -我的推荐- - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <div v-show="isShowReferrals">
                    <h2 class="fw-700 mb-5">{{$t("userData.referees")}}</h2>
                    <v-container fluid grid-list-xl pt-2>
                      <v-layout row wrap>
                        <div class="mr-3 mb-3 app-card" v-for="(user, index) in referralList" :key="index">
                          <div class=" text-xs-center follow-w mb-3 mt-2 profile-card-bg" :style="{backgroundImage: 'url('+user.coverImage+')'}">
                            <v-avatar color="primary" class="pointer mt-4" size="40" @click=goUserData(user.userName)>
                              <img v-show="user.image != null" :src="user.image" :alt="user.userName" />
                              <span v-show="user.image == null" class="headline white--text">
                                {{ user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '' }}
                              </span>
                            </v-avatar>
                          </div>
                          <div class="user-list-content">
                            <div class="text-xs-center pt-2">
                              <h4 class="fw-bold pointer" @click=goUserData(user.userName)>{{user.nickName}}</h4>
                              <span>@{{user.userName}}</span>
                            </div>
                            <div class="text-xs-center mb-2">
                              <div v-if="user.userId != userId">
                                <v-btn class="primary" dark small @click="referralFollow(user.userId)">
                                  <span v-show="user.status == '1' ? true : false">
                                    {{$t("common.unfollow")}}
                                  </span>
                                  <span v-show="user.status == '1' ? false : true">
                                    <Icon type="plus-round" color="white--text"></Icon>
                                    {{$t("common.follow")}}
                                  </span>
                                </v-btn>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-layout>
                    </v-container>
                  </div>
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - -奖励记录- - - - - - - - - - - - - - - -->
                  <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                  <div v-show="isShowRewardRecords">
                    <h2 class="fw-700 mb-5">{{$t("userData.rewardRecords")}}</h2>
                    <!-- <div v-for="(bonusRecord,index) in bonusRecordList" class="media-listing">
                      <div class="mt-3 mb-3 ml-3 mr-3">
                        <div class="mt-3 font-md">
                          <span>{{ dateFormat(bonusRecord.actionTimestamp) }}</span>
                          <span class="ml-5">{{ bonusRecord.bonus != null ? bonusRecord.bonus.toFixed(4) : 0.0000 }} IOB Power for </span>
                          <span class="pointer primary--text">
                            <router-link :to="'/post/' + bonusRecord.postId">{{ bonusRecord.type }}</router-link>
                          </span>
                        </div>
                      </div>
                      <v-divider></v-divider>
                    </div> -->
                    <v-data-table :headers="bonusRecordTableHeaders" :items="bonusRecordList" class="elevation-1 mb-5" hide-actions>
                      <template slot="items" slot-scope="props">
                          <td>{{ dateFormat(props.item.actionTimestamp) }}</td>
                          <td>{{ dateFormat(props.item.timestamp) }}</td>
                          <td class="primary--text pointer" @click="">
                            <router-link :to="'/post/' + props.item.postId">
                              {{ props.item.bonus != null ? props.item.bonus.toFixed(4) : 0.0000 }} IOB Power for {{ props.item.type }}
                            </router-link>
                          </td>
                      </template>
                  </v-data-table>
                    <div v-show="bonusRecordList.length > 0">
                      <Page :total="totalRewardRecordsNum" :pageSize="10" size="small" transfer @on-change="getBonusRecordsListByPage" class="mt-2 mb-5 text-xs-center"></Page>
                    </div>
                  </div>
                    <!-- ******************************************************* -->
                   </v-container>
                   </v-card> 
                  <!--  -->
                </div>
            </v-flex>

          </v-layout>
        </v-container>
      </div>
  </div>
</template>
<style>
</style>
<script>
import Vue from 'vue'
import config from '../../config.js'
import { mapGetters } from "vuex";
import { eventBus } from '../../assets/js/eventBus.js'
export default {
  data() {
    return {
      userId: this.$store.getters.user != null ? this.$store.getters.user.userId : null, //用户ID
      username: this.$route.params.username, //用户名
      isShowPosting: true, //是否显示帖子div
      isShowMicroArticle: false, //是否显示微文div
      isShowComments: false, //是否显示评论div
      isShowReply: false, //是否显示回复div
      isShowForward: false, //是否显示转发div
      isShowUpvotes: false, //是否显示点赞的帖子div
      isShowDownvotes: false, //是否显示点踩的帖子div
      isShowCollections: false, //是否显示我收藏的帖子div
      isShowRewardRecords: false,//是否显示奖金纪录的div
      isShowReferrals: false, //是否显示推荐人
      postingList: [], //该用户的帖子集合
      microArticleList: [], //该用户的微文集合
      totalPostingNum: 0, //总帖子数
      totalMicroArticleNum: 0, //总微文数
      totalCommentsNum: 0, //总评论数
      totalReplyNum: 0, //总回复数
      totalForwardNum: 0, //总转发数
      userDetail: {}, //该用户详情对象
      postingCommentsList: [], //该用户的评论集合
      commentsPostingList: [], //评论相对应的帖子集合
      postingReplyList: [], //该用户的回复集合
      postingForwardList: [], //该用户的转发集合
      parentCommentList: [], //回复的父级评论集合
      collectionPostList: [], //收藏的帖子集合
      totalCollectionPostNum: 0, //收藏的帖子数
      upvotePostList: [], //赞的帖子集合
      totalUpvoteNum: 0, //赞的总帖子数
      downvotePostList: [], //踩的帖子集合
      totalDownvoteNum: 0, //踩的总帖子数
      referralList: [], //我的推荐人集合
      totalRewardRecordsNum: 0,//总奖励次数
      bonusRecordTableHeaders: [
        { text: this.$t('userData.bonusRecordTableHeaders.actionTimestamp'), align: 'left', sortable: false},
        { text: this.$t('userData.bonusRecordTableHeaders.timestamp'), align: 'left', sortable: false},
        { text: this.$t('userData.bonusRecordTableHeaders.record'), align: 'left', sortable: false}
      ],
      bonusRecordList: [],//奖金纪录集合
      isShowViewImageModal: false, //是否显示查看大图的modal
      formFollow: { //关注
        userId: '',
        followerId: '',
      },
      isFollow: false, //是否已关注
      followingNum: 0, //关注人数
      followerNum: 0, //粉丝人数
    }
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created(){
      // 数字格式化
      Vue.filter('NumFormat', function(value) {
       if(!value) return '0.00';
         var intPart = Number(value).toFixed(0); //获取整数部分
         intPart = intPart > value ? intPart - 1 : intPart; // 若四舍五入进了1则减去1
         var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
         var floatPart = ".00"; //预定义小数部分
         var value2Array = value.split(".");
         //=2表示数据有小数位
         if(value2Array.length == 2) {
          floatPart = value2Array[1].toString(); //拿到小数部分
          if(floatPart.length == 1) { //补0,实际上用不着
           return intPartFormat + "." + floatPart + '0';
          } else {
           return intPartFormat + "." + floatPart;
          }
         } else {
          return intPartFormat + floatPart;
         }
      })
    },
  mounted: function() {
    if (this.$route.params.username) {
      if (this.$route.params.username.indexOf('@') == 0) {
        this.username = this.$route.params.username.substring(1);
      }
      //加载基础数据
      this.getBaseData();
      //加载帖子选项
      this.getMenuData("posting");
    }
  },
  watch: {
    //监听路由的username变化之后就重新加载页面
    $route() {
      if (this.$route.params.username) {
        if (this.$route.params.username.indexOf('@') == 0) {
          this.username = this.$route.params.username.substring(1);
        } else {
          this.username = this.$route.params.username;
        }
      }
    },
    username() {
      if (this.username) {
        //加载基础数据
        this.getBaseData();
        //加载帖子选项
        this.getMenuData("posting");
      }
    },
  },
  methods: {
    //查询基础数据
    getBaseData() {
      //查询用户信息
      this.$http.get(config.baseUrl + "userDetail/open/getUserInfo/" + this.username).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.userDetail = data.result;
          document.title = this.userDetail.nickName + "(@" + this.userDetail.userName + ")——SiP";
        } else {
          this.$router.push({ name: 'page404' });
        }
      });
      //查询用户的微文总数
      this.$http.get(config.baseUrl + "microArticle/open/countMicroArticlesByUsername/" + this.username).then((successData) => {
        this.totalMicroArticleNum = successData.data.result;
      });
      //查询用户的评论总数
      this.$http.get(config.baseUrl + "comments/open/countCommentsByUsername/" + this.username).then((successData) => {
        this.totalCommentsNum = successData.data.result;
      });
      //查询用户的回复总数
      this.$http.get(config.baseUrl + "comments/open/countReplyByUsername/" + this.username).then((successData) => {
        this.totalReplyNum = successData.data.result;
      });
      //查询用户的转发总数
      this.$http.get(config.baseUrl + "posting/open/countForwardsByUsername/" + this.username).then((successData) => {
        this.totalForwardNum = successData.data.result;
      });
      //查询用户赞的帖子总数
      this.$http.get(config.baseUrl + "posting/open/countPosts/upvote/" + this.username).then((successData) => {
        this.totalUpvoteNum = successData.data.result;
      });
      //查询用户踩的帖子总数
      this.$http.get(config.baseUrl + "posting/open/countPosts/downvote/" + this.username).then((successData) => {
        this.totalDownvoteNum = successData.data.result;
      });
      //查询用户的喜欢总数
      this.$http.get(config.baseUrl + "collection/open/countPostingByUsername/" + this.username).then(successData => {
        this.totalCollectionPostNum = successData.data.result;
      });
      //查询用户的奖励记录总数
      this.$http.get(config.baseUrl + "bonusRecord/open/countBonusRecordByUsername/" + this.username).then(successData => {
        this.totalRewardRecordsNum = successData.data.result;
      });
      //查询是否已经关注了该用户
      if (localStorage.getItem('token')) {
        this.formFollow.userId = this.$store.state.user.id;
        this.formFollow.followerId = this.username;
        this.$http.post(config.baseUrl + "follow/isFollow", this.formFollow).then((successData) => {
          this.isFollow = successData.data.result;
        });
      }
      //查询关注人数
      this.$http.get(config.baseUrl + "follow/open/countFollowingByUsername/" + this.username).then(successData => {
        this.followingNum = successData.data.result;
      });
      //查询粉丝人数
      this.$http.get(config.baseUrl + "follow/open/countFollowerByUsername/" + this.username).then(successData => {
        this.followerNum = successData.data.result;
      });
    },
    //切换菜单加载数据
    getMenuData(name) {
      switch (name) {
        //查询帖子
        case "posting":
          this.isShowPosting = true;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getPostingList();
          break;
          //查询微文
        case "microArticle":
          this.isShowPosting = false;
          this.isShowMicroArticle = true;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getMicroArticleList();
          break;
          //查询评论
        case "comments":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = true;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getCommentList();
          break;
          //查询回复
        case "reply":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = true;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getReplyList();
          break;
          //查询转发
        case "forward":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = true;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getForwardList();
          break;
          // 查询点赞的帖子
        case "upvotes":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = true;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getUpvotePostListByPage(1);
          break;
          // 查询点踩的帖子
        case "downvotes":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = true;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getDownvotePostListByPage(1);
          break;
          // 查询收藏
        case "collections":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = true;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getCollectionPostingList();
          break;
          //查询推荐人
        case "referees":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = true;
          this.isShowRewardRecords = false;
          this.getReferralList();
          break;
        // 查询奖金纪录
        case "rewardRecords":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = true;
          this.getBonusRecordsListByPage(1);
          break;
        default:
          break;
      }
    },
    //分页查询用户的帖子
    getPostingList() {
      let postingUrl = config.baseUrl + "posting/open/selByUsername/" + this.username + "/0/5";
      this.$http.get(postingUrl).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.postingList = data.result.postingList;
          this.totalPostingNum = data.result.totalElements;
        } else {
          this.postingList = [];
          this.totalPostingNum = 0;
        }
      });
    },
    // 分页查询用户的微文
    getMicroArticleList() {
      let url = config.baseUrl + "microArticle/open/getMicroArticleByUsername/" + this.username + "/0/5";
      this.$http.get(url).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.microArticleList = data.result;
        } else {
          this.microArticleList = [];
        }
      });
    },
    //分页查询用户的评论
    getCommentList() {
      let commentsUrl = config.baseUrl + "comments/open/selCommentsByUsername/" + this.username + "/0/5";
      this.$http.get(commentsUrl).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.postingCommentsList = data.result.postingCommentsList;
          this.commentsPostingList = data.result.commentsPostingList;
          this.totalCommentsNum = data.result.totalElements;
        } else {
          this.postingCommentsList = [];
          this.commentsPostingList = [];
          this.totalCommentsNum = 0;
        }
      });
    },
    //分页查询用户的回复
    getReplyList() {
      let replyUrl = config.baseUrl + "comments/open/selReplyByUsername/" + this.username + "/0/5";
      this.$http.get(replyUrl).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.postingReplyList = data.result.postingReplyList;
          this.parentCommentList = data.result.parentCommentList;
          this.totalReplyNum = data.result.totalElements;
        } else {
          this.postingReplyList = [];
          this.parentCommentList = [];
          this.totalReplyNum = 0;
        }
      });
    },
    //分页查询用户的转发
    getForwardList() {
      let forwardUrl = config.baseUrl + "posting/open/forwardByUsername/" + this.username + "/0/5";
      this.$http.get(forwardUrl).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.postingForwardList = data.result.postingForwardList;
          this.totalForwardNum = data.result.totalElements;
        } else {
          this.postingForwardList = [];
          this.totalForwardNum = 0;
        }
      });
    },
    //查询用户喜欢的帖子
    getCollectionPostingList() {
      let postingUrl = config.baseUrl + "collection/open/getPostingByUsername/" + this.username + "/0/5";
      this.$http.get(postingUrl).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.collectionPostList = data.result.postingList;
          this.totalCollectionPostNum = data.result.totalElements;
        } else if (data.resCode == -1) {
          this.collectionPostList = [];
          this.totalCollectionPostNum = 0;
        }
      });
    },
    // 分页查询用户喜欢的帖子
    getCollectionPostByPage(pageNo) {
      let postingUrl = config.baseUrl + "collection/open/getPostingByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(postingUrl).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.collectionPostList = data.result.postingList;
          this.totalCollectionPostNum = data.result.totalElements;
        } else if (data.resCode == -1) {
          this.collectionPostList = [];
          this.totalCollectionPostNum = 0;
          this.$Notice.info({
            title: "You don't have any collections yet."
          });
        }
      });
    },
    //分页查询投票的帖子集合
    getUpvotePostListByPage(pageNo) {
      let api = config.baseUrl + "posting/open/getPosts/upvote/" + (pageNo - 1) + "/5/" + this.username;
      this.$http.get(api).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.upvotePostList = data.result;
        } else if (data.resCode == -1) {
          this.upvotePostList = [];
        }
      });
    },
    //分页查询反对的帖子集合
    getDownvotePostListByPage(pageNo) {
      let api = config.baseUrl + "posting/open/getPosts/downvote/" + (pageNo - 1) + "/5/" + this.username;
      this.$http.get(api).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.downvotePostList = data.result;
        } else if (data.resCode == -1) {
          this.downvotePostList = [];
        }
      });
    },
    //获得我的推荐的人的集合
    getReferralList() {
      this.$http.get(config.baseUrl + "follow/open/getReferralsByUsername/" + this.username).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.referralList = data.result;
          this.userDetail.invitationNumber = data.result.length;
          // if (localStorage.getItem("token")) {
          //     this.getIsFollowByUserId("referrals");
          // }
        } else {
          this.referralList = [];
          this.userDetail.invitationNumber = 0;
        }
      });
    },
    //分页查询奖金纪录集合
    getBonusRecordsListByPage(pageNo) {
      let api = config.baseUrl + "bonusRecord/open/getBonusRecords/" + (pageNo - 1) + "/10/" + this.username;
      this.$http.get(api).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.bonusRecordList = data.result;
        } else if (data.resCode == -1) {
          this.bonusRecordList = [];
        }
      });
    },
    //推荐人的关注与取消
    referralFollow(followerId) {
      if (localStorage.getItem("token")) {
        this.formFollow.userId = this.$store.state.user.id;
        this.formFollow.followerId = followerId;
        this.$http.post(config.baseUrl + "follow/saveFollow", this.formFollow).then((successData) => {
          let data = successData.data;
          if (data.resCode == 0) {
            for (var i = 0; i < this.referralList.length; i++) {
              if (this.referralList[i].userId == followerId) {
                this.referralList[i].status = "1";
              }
            }
            this.followingNum += 1;
          } else if (data.resCode == 1) {
            for (var i = 0; i < this.referralList.length; i++) {
              if (this.referralList[i].userId == followerId) {
                this.referralList[i].status = "0";
              }
            }
            this.followingNum -= 1;
          } else if (data.resCode == -3) {
            this.$Message.error("Can not follow yourself!");
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //查看头像大图
    viewBigImage() {
      this.isShowViewImageModal = true;
    },
    //路由到查看用户详情页面
    goUserData(username) {
      this.$router.push({
        name: 'userData',
        params: {
          username: '@' + username
        }
      });
    },
    //路由到关注页面
    goFollow(followOption) {
      sessionStorage.setItem("followOption", followOption);
      this.$router.push({ name: 'follow', params: { username: '@' + this.username } });
    },
    //关注
    follow() {
      if (localStorage.getItem('token')) {
        this.formFollow.userId = this.$store.state.user.id;
        this.formFollow.followerId = this.userDetail.userId;
        this.$http.post(config.baseUrl + "follow/saveFollow", this.formFollow).then((successData) => {
          let data = successData.data;
          if (data.resCode == 0) {
            // this.$Message.success("Success!");
            this.isFollow = true;
          } else if (data.resCode == 1) {
            // this.$Message.info("Cancel Follow!");
            this.isFollow = false;
          } else if (data.resCode == -3) {
            this.$Message.error("Can not follow yourself!");
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //根据id查看帖子详情
    getPostingById(postingId) {
      this.$router.push({
        name: 'postingsel',
        params: {
          username: this.username,
          postingId: postingId
        }
      });
    },
    // 跳转微文详情页
    gotoMicroArticle(microArticle) {
      this.$router.push({
        name: 'microArticle',
        params: {
          userName: '@' + this.username,
          microArticleId: microArticle.microArticleId
        }
      });
    },
    //分页查询用户的帖子
    getPostingByPage(pageNo) {
      let postingUrl = config.baseUrl + "posting/open/selByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(postingUrl).then((successData) => {
        let data = successData.data;
        this.postingList = data.result.postingList;
        this.totalPostingNum = data.result.totalElements;
      });
    },
    //分页查询用户的微文
    getMicroArticleByPage(pageNo) {
      let url = config.baseUrl + "microArticle/open/getMicroArticleByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(url).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.microArticleList = data.result;
        } else {
          this.microArticleList = [];
        }
      });
    },
    //分页查询用户的转发
    getForwardByPage(pageNo) {
      let postingUrl = config.baseUrl + "posting/open/forwardByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(postingUrl).then((successData) => {
        let data = successData.data;
        this.postingForwardList = data.result.postingForwardList;
        this.totalForwardNum = data.result.totalElements;
      });
    },
    //分页查询用户的评论
    getCommentsByPage(pageNo) {
      let commentsUrl = config.baseUrl + "comments/open/selCommentsByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(commentsUrl).then((successData) => {
        let data = successData.data;
        this.postingCommentsList = data.result.postingCommentsList;
        this.commentsPostingList = data.result.commentsPostingList;
        this.totalCommentsNum = data.result.totalElements;
      });
    },
    //分页查询用户的回复
    getReplyByPage(pageNo) {
      let replyUrl = config.baseUrl + "comments/open/selReplyByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(replyUrl).then((successData) => {
        let data = successData.data;
        this.postingReplyList = data.result.postingReplyList;
        this.parentCommentList = data.result.parentCommentList;
        this.totalReplyNum = data.result.totalElements;
      });
    },
    //打开新窗口预览图片
    openNewWindowViewImage(imageUrl) {
      if (imageUrl) {
        window.open(imageUrl);
      }
    },
    //点击其它区域隐藏区块
    hideBlock(event) {

    },
    //格式化注册时间
    regTimeFormat(time) {
      return formatTime(time, this.$i18n.locale);
    },
    //日期格式化
    dateFormat(time) {
        let timeOffset = -28800000;
        if (this.user) {
            timeOffset = this.user.timeOffset;
        }
        return formatDate(time, timeOffset, this.$i18n.locale);
    }
  },

}

</script>



// WEBPACK FOOTER //
// UserData.vue?ba462ef0